export const isAgreementCode = (code?: string) => {
    if (code === undefined) {
      return false;
    }
  
    return code.startsWith('8');
  };

export const validateAgreementCode = (code?: string | null) => {
  if (!code) {
    return 'Campo obrigatório';
  }

  if (!isAgreementCode(code)) {
    return 'Informe um número de convênio válido';
  }
  return undefined;
};


// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/validator/validateBarcode/validateAgreementCode/index.ts